import { ISavedSearch, IToastMessage } from '@components';

export interface ISavedSearches {
  savedSearches: ISavedSearch[];
  selectedSearch?: ISavedSearch;
  isDeleting?: boolean;
  isSaving?: boolean;
  toast?: IToastMessage;
}
